<template>
  <div :class="fieldType">
    <div :class="['input-wrapper', { 'input_error': error }, { 'input_disabled': disabled }]">
      <label
        v-if="label"
        :for="id"
        class="input__label"
      >
        {{ label }}
        <span v-if="required" class="input__label-required">*</span>
      </label>
      <div class="input__field-container">
        <input
          :id="id"
          v-mask="inputMask"
          v-bind="$attrs"
          :value="value"
          class="input__field"
          @input="onInput($event.target.value)"
          @focus="error = false"
        >
<!--        <span v-show="fieldType" class="diya__btn" @click="fieldTypeAction">-->
<!--          <span class="diya__btn-text">{{textButtonDiya}}</span>-->
<!--          <span class="diya__btn-icon" @click="fieldTypeAction">-->
<!--            <img src="./../../assets/img/icons/diya.svg" alt="diya-icon">-->
<!--          </span>-->
<!--        </span>-->
      </div>
      <transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="input__error-msg"
      >
        {{ errorMsg }}
      </span>
      </transition>
    </div>
  </div>
</template>

<script>
  import { VueMaskDirective } from 'v-mask'

  export default {
    name: 'BaseInput',

    directives: { mask: VueMaskDirective },

    inheritAttrs: false,

    props: {
      fieldType: {
        type: String,
        default: ''
      },
      textButtonDiya: {
        type: String,
        default: 'VIN код через'
      },
      fieldTypeAction: {
        type: Function,
        default: () => {}
      },
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      errorMsg: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      mask: {
        type: String,
        default: ''
      }
    },

    data () {
      return {
        error: null
      }
    },

    computed: {
      id () {
        return `input-${this._uid}`
      },
      required () {
        return 'required' in this.$attrs && this.$attrs.required
      },
      inputMask () {
        switch (this.mask) {
        case 'tel': return this.$store.state.currentLang === 'uk' ? '+380-##-###-##-##' : '+###########'
        case 'vin': return 'NNNNNNNNNNNNNNNNN'
        default: return ''
        }
      }
    },

    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },

    methods: {
      onInput (value) {
        this.$emit('input', value)
      }
    }
  }
</script>

<style lang="scss">
  $padding-for-error: 28px;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    box-shadow: 0 0 0 30px $c-gray-light inset !important;
  }

  .input {
    &-wrapper {
      position: relative;
      //min-width: 290px;
      //max-width: 335px;
      padding-bottom: $padding-for-error;
    }

    &_disabled {
      pointer-events: none;
    }

    &__label {
      display: inline-block;
      padding-bottom: 1em;
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 16px;
      color: $c-input-grey;

      &-required {
        color: $c-active-light;
      }
    }

    &__field {
      display: block;
      width: 100%;
      padding: 0.75em 1.3em;
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 15px;
      line-height: 1;
      background-color: $c-gray-light;
      border: none;
      border-radius: 4px;
      outline: none;
      caret-color: $c-active-light;
      appearance: none;
      transition: 0.3s;

      @include mobile {
        font-size: 13px;
      }

      &-container {
        position: relative;

        &::after {
          // error icon
          position: absolute;
          top: 50%;
          right: 5%;
          display: inline-block;
          width: 1.5em;
          height: 1.5em;
          padding-top: 0.25em;
          color: $c-white;
          text-align: center;
          content: "!";
          background-color: $c-active-light;
          border-radius: 50%;
          opacity: 0;
          transition: opacity 0.3s;
          transform: translateY(-50%);
        }
      }

      @include hover {
        background-color: $c-gray;
      }

      &:focus {
        background-color: $c-white;
        box-shadow: 0 2px 10px 0 $c-shadow;
      }
    }

    &__error-msg {
      position: absolute;
      top: 77%;
      left: 0;
      font-size: 12px;
      color: $c-active-light;
    }

    &_error {
      .input {
        &__field {
          padding-right: 3.5em;
          background-color: $c-error-light;

          &-container {
            &::after {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  //
  //.diya {
  //  max-width: 600px;
  //
  //  &:hover {
  //    cursor: pointer;
  //  }
  //
  //  .input-wrapper {
  //    max-width: 600px;
  //  }
  //
  //  .diya__btn {
  //    height: 100%;
  //    display: flex;
  //    align-items: center;
  //    position: absolute;
  //    padding-right: 20px;
  //    right: 0;
  //    top: 0;
  //    z-index: 10;
  //
  //    @include mobile {
  //      padding-right: 12px;
  //    }
  //
  //    &-text {
  //      padding-left: 16px;
  //      position: relative;
  //
  //      @include mobile {
  //        font-size: 0;
  //        padding-left: 6px;
  //      }
  //
  //      &::before {
  //        content: "";
  //        display: block;
  //        position: absolute;
  //        top: calc(50% - 12px);
  //        left: 0;
  //        width: 2px;
  //        height: 24px;
  //        background-color: #000;
  //      }
  //    }
  //
  //    &-icon {
  //      padding-left: 8px;
  //    }
  //  }
  //}
</style>
